import { FC, lazy } from 'react';
import { useContext } from 'react';
import { getCurrentSubdomain } from '@mybonum/utils';
import { NavLink } from 'react-router';

import { SidebarContext } from '@/contexts/sidebar/context.ts';
import { EAdminRoutes } from '@/services/router/enums.ts';

const LogoIconDefault = lazy(() => import('@/assets/icons/logo.svg?react'));
const LogoFACCMIcon = lazy(() => import('@/assets/icons/logo-faccm.svg?react'));
const LogoCompactIcon = lazy(() => import('@/assets/icons/logo-compact.svg?react'));

interface ILogoProps {
    path?: EAdminRoutes;
}

export const Logo: FC<ILogoProps> = ({ path = EAdminRoutes.Dashboard }) => {
    const sidebarContext = useContext(SidebarContext);
    const collapsed = sidebarContext?.collapsed ?? false;
    const { isFACCM } = getCurrentSubdomain();

    if (collapsed) {
        return (
            <NavLink to={path}>
                <LogoCompactIcon />
            </NavLink>
        );
    }

    const LogoIcon = isFACCM ? LogoFACCMIcon : LogoIconDefault;

    return (
        <NavLink to={path}>
            <LogoIcon />
        </NavLink>
    );
};
